module.exports = __webpack_public_path__ + "img/dose-graph-mobile.7cc25657.png";